import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { DomainEntityService } from 'sjx/common/service/domain-entity.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    private readonly serverErrorFlagKey = 'serverErrorFlag';
    /**
     * Constructor
     */
    constructor(private _authService: AuthService, private router: Router, private route: ActivatedRoute, private _domainEntityService: DomainEntityService) { }


    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Clone the request object
        let newReq = req.clone();
        let role = sessionStorage.getItem('activeRole');
        let orgId = sessionStorage.getItem('orgId');

        // Request
        //
        // If the access token didn't expire, add the Authorization header.
        // We won't add the Authorization header if the access token expired.
        // This will force the server to return a "401 Unauthorized" response
        // for the protected API routes which our response interceptor will
        // catch and delete the access token from the local storage while logging
        // the user out from the app.
            if (this._authService.accessToken && !AuthUtils.isTokenExpired(this._authService.accessToken)) {
                // console.log(AuthUtils.isTokenExpired(this._authService.accessToken));
                newReq = req.clone({
                    setHeaders: {
                        // "Authorization": "Bearer " + this._authService.idToken,
                        "Authorization": this._authService.accessToken,
                        'x-nj-usr-role': role,
                        // 'x-se-org-id': orgId,
                        'x-nj-session-id': this._authService.sessionId,
                        // 'x-nj-access-token': this._authService.accessToken
                    }
                });
                // Reset the timer before making the API request
            }

        // Response
        return next.handle(newReq).pipe(
            catchError((error) => {

                // Catch "401 Unauthorized" responses
                if (error instanceof HttpErrorResponse && error.status === 401) {
                    // Sign out
                    this._authService.signOut();

                    // Reload the app
                    location.reload();
                } else if (error.status === 0) {
                    // Handle network error
                    console.error('Network error occurred:', error);
                    const isOnline: boolean = sessionStorage.getItem('isOnline') === 'true';
                    if (!isOnline) {
                        sessionStorage.setItem(this.serverErrorFlagKey, 'true');
                        this.router.navigate(['/error-network']);
                    }
                }


                return throwError(error);
            })
        );
    }
}
